<template>
  <div class="container px-3" v-if="searchActive">
    <div class="row justify-content-center" v-if="hits.length > 0">
      <vertical-card-search
        class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6"
        v-for="hit in hits"
        :key="hit.objectID"
        :hit="hit"
      />
    </div>
    <div v-else>
      <h1>{{ $t("search.no_results") }}</h1>
    </div>
  </div>
</template>
<script>
import algoliasearch from "algoliasearch";
import VerticalCardSearch from "@/components/landing/search/VerticalCardSearch.vue";
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";

export default {
  name: "AllContent",
  metaInfo: () => {
    return {
      title: i18n.global.t("browse.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(i18n.global.t("browse.meta.description")),
      ],
    };
  },
  components: { VerticalCardSearch },
  computed: {
    searchActive() {
      return this.query.length > 0;
    },
    noResults() {
      return this.$store.state.search.noResults;
    },
  },
  data() {
    return {
      query: "*",
      hits: [],
    };
  },
  mounted() {
    this.$meta.canonicalUrls(
      this.$t("routes.browse", "es"),
      this.$t("routes.browse", "en")
    );
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      index.search(this.query).then(({ hits }) => {
        this.hits = hits;
        console.log(hits[0]);
      });

      setTimeout(() => {
        this.$emit("search", this.query);
      }, 100);
    },
  },
};

const client = algoliasearch("C1XB5XK87T", "691228d05e070e772a2994476e3ee194");
const index = client.initIndex("movies");
</script>
<style lang="scss"></style>
